import defaultConfig from '../default-config.json'

export const MAIN_ROUTE = '/'
export const PROFILE_ROUTE = '/profile'
export const ORDER_ROUTE = '/order'
export const THANKS_ROUTE = '/check'
export const FAQ_ROUTE = '/faq'
export const DELIVERY_ROUTE = '/delivery'
export const CONTACTS_ROUTE = '/contacts'
export const POLICY_ROUTE = '/privacy-policy'
export const WARRANTY_ROUTE = '/warranty'
export const GREETING_ROUTE = '/greeting'
//public teaser for a predefined catalog book (first pages + an order CTA)
export const PREVIEW_BOOK_ROUTE = '/preview/book'

// languages with a text field in the DB (us has none — the us site reads en texts)
export const textLangs = defaultConfig.availableLang.filter(lang => lang !== 'us')

export const availableFaceParts = ['zest','decorations','eye','lips','eyebrows','hair','beard','nose','glasses']
export const sequenceFaceParts = ['eye','eyebrows','nose','lips','hair','beard','zest','decorations','glasses']
export const availableMoveFaceParts = ['eye','eyebrows','nose','lips','zest']
export const availableSkinFaceParts = ['beard','nose','hair']
export const sceneBlank = {
  "name": "Scene_000",
  "color": "color",
  "topic": [],
  "type": "empty",
  "settings": {},
  "mainText": {
      "couple_man": {"ua": "", "en": "", "pl": "", "cs": "", "de": "", "sk": ""},
      "couple_woman": {"ua": "", "en": "", "pl": "", "cs": "", "de": "", "sk": ""},
      "couple_him": {"ua": "", "en": "", "pl": "", "cs": "", "de": "", "sk": ""},
      "couple_her": {"ua": "", "en": "", "pl": "", "cs": "", "de": "", "sk": ""},
      "couple": {"ua": "", "en": "", "pl": "", "cs": "", "de": "", "sk": ""},
      "only_man": {"ua": "", "en": "", "pl": "", "cs": "", "de": "", "sk": ""},
      "only_woman": {"ua": "", "en": "", "pl": "", "cs": "", "de": "", "sk": ""}
  },
  "otherText": []
}
export const drawAboveSceneList = ['scene_099', 'scene_093', 'scene_190']
//scenes that draw a spaghetti strand connecting the two people's mouths (follows each person's
//lips position). Replaces the old fixed swap/scene_030.svg overlay (kept as an asset for reference).
export const drawLipsStrandList = ['scene_030']

/*ADMIN PART*/
export const ADMIN_ROUTE = '/admin'
export const SCENES_ROUTE = '/admin/scenes'
export const ADD_SCENES_ROUTE = '/admin/scenes/add'
export const EDIT_SCENES_ROUTE = '/admin/scenes/edit'
export const STATS_ROUTE = '/admin/stats'
export const DIGITAL_ORDERS_ROUTE = '/admin/orders/digital'
export const ORDERS_ROUTE = '/admin/orders'
//NB: the `VOUCHERS_ROUTE` page is the percentage-discount promocode manager (labeled "Promocodes"
//in the admin UI). The single-use 100%-off Etsy codes live under GIFT_VOUCHERS_ROUTE (labeled
//"Vouchers"). See models/GiftVoucher on the server.
export const VOUCHERS_ROUTE = '/admin/vouchers'
export const ADD_VOUCHERS_ROUTE = '/admin/vouchers/add'
export const EDIT_VOUCHERS_ROUTE = '/admin/vouchers/edit'
export const GIFT_VOUCHERS_ROUTE = '/admin/gift-vouchers'
export const COVERS_ROUTE = '/admin/covers'
export const ADD_COVERS_ROUTE = '/admin/covers/add'
export const EDIT_COVERS_ROUTE = '/admin/covers/edit'
export const USERS_ROUTE = '/admin/users'
export const PREDEFINED_BOOKS_ROUTE = '/admin/predefined-books'
export const EDIT_PREDEFINED_BOOK_ROUTE = '/admin/predefined-books/edit'

// human-readable recipient labels for the themeId key used by predefined books
export const themeIdLabels = {
  only_woman: 'Woman (single)',
  only_man: 'Man (single)',
  couple: 'Couple',
  couple_man: 'Couple — husband',
  couple_woman: 'Couple — wife',
  couple_him: 'Couple — for him',
  couple_her: 'Couple — for her'
}